import { render, staticRenderFns } from "./CidadeSobreCard.vue?vue&type=template&id=0f48a829&"
import script from "./CidadeSobreCard.vue?vue&type=script&lang=js&"
export * from "./CidadeSobreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports